
// import LegislationOverview from "../Pages/LegislationPage/LegislationTab/LegislationOverview";
// import LegislationAct from "../Pages/LegislationPage/LegislationTab/LegislationAct";
// import LegislationRegulation from "../Pages/LegislationPage/LegislationTab/LegislationRegulation";
// import LegislationMarineRelatedInfomation from "../Pages/LegislationPage/LegislationTab/LegislationMarineRelatedInfomation";
// import LegislationMarineNotices from "../Pages/LegislationPage/LegislationTab/LegislationMarineNotices";
// import LegislationMarineInformationNotices from "../Pages/LegislationPage/LegislationTab/LegislationMarineInformationNotices";
// import LegislationMarineAlerts from "../Pages/LegislationPage/LegislationTab/LegislationMarineAlerts";
// import LegislationMarineSafetyFlash from "../Pages/LegislationPage/LegislationTab/LegislationMarineSafetyFlash";
// import LegislationTrainingStandardsCode from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode";
// import LegislationTrainingStandardsCode2 from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode2";
// import LegislationTrainingStandardsCode3 from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode3";
// import LegislationTrainingStandardsCode4 from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode4";
// import LegislationInternationalInstrumentsCode from "../Pages/LegislationPage/LegislationTab/LegislationInternationalInstrumentsCode";
// import LegislationInternationalInstrumentsCode2 from "../Pages/LegislationPage/LegislationTab/LegislationInternationalInstrumentsCode2 ";
// import LegislationInternationalInstrumentsCode3 from "../Pages/LegislationPage/LegislationTab/LegislationInternationalInstrumentsCode3";
// import LegislationInternationalInstrumentsCode4 from "../Pages/LegislationPage/LegislationTab/LegislationInternationalInstrumentsCode4";
// import LegislationSearchResults from "../Pages/LegislationPage/LegislationTab/LegislationSearchResults";

// const LegislationAccordionSections = [
//   {
//     title: "ACTS AND REGULATIONS",
//     items: [
//       { id: "acts-overview", label: "OVERVIEW", component: <LegislationOverview /> },
//       { id: "acts", label: "ACTS", component: <LegislationAct /> },
//       { id: "regulations", label: "REGULATIONS", component: <LegislationRegulation /> },
//     ],
//   },
//   {
//     title: "MARINE RELATED",
//     items: [
//       { id: "marine-related", label: "Marine RELATED INFOMATION", component: <LegislationMarineRelatedInfomation/> },
//       { id: "marine-notices", label: "MARINE NOTICES", component: <LegislationMarineNotices /> },
//       { id: "marine-information-notices", label: "MARINE INFOMATION NOTICE", component: <LegislationMarineInformationNotices /> },
//       { id: "marine-alert", label: "MARINE ALERT", component: <LegislationMarineAlerts /> },
//       { id: "marine-safety-flash", label: "MARINE SAFETY FLASH", component: <LegislationMarineSafetyFlash /> },
//     ],
//   },
//   {
//     title: "TRAINING STANDARDS CODES",
//     items: [
//       { id: "training-standards", label: "CODES", component: <LegislationTrainingStandardsCode/> },
//       { id: "training-standards-code-2", label: "CODES 2", component: <LegislationTrainingStandardsCode2 /> },
//       { id: "training-standards-code-3", label: "CODES 3", component: <LegislationTrainingStandardsCode3 /> },
//       { id: "training-standards-code-4", label: "CODES 4", component: <LegislationTrainingStandardsCode4 /> },
//     ],
//   },
//   {
//     title: "INTERNATIONAL INSTRUMENTS",
//     items: [
//       { id: "intl-instruments", label: "INSTRUMENTS", component: <LegislationInternationalInstrumentsCode /> },
//       { id: "intl-instruments-code-2", label: "INSTRUMENTS 2", component: <LegislationInternationalInstrumentsCode2/> },
//       { id: "intl-instruments-code-3", label: "INSTRUMENTS 3", component: <LegislationInternationalInstrumentsCode3 /> },
//       { id: "intl-instruments-code-4", label: "INSTRUMENTS 4", component: <LegislationInternationalInstrumentsCode4 /> },
//     ],
//   },
//   {
//     title: "SEARCH RESULTS",
//     items: [
//       { id: "search-results", label: "Results", component: <LegislationSearchResults /> }
//     ]
//   },
// ];

// export default LegislationAccordionSections;


import LegislationOverview from "../Pages/LegislationPage/LegislationTab/LegislationOverview";
import LegislationAct from "../Pages/LegislationPage/LegislationTab/LegislationAct";
import LegislationRegulation from "../Pages/LegislationPage/LegislationTab/LegislationRegulation";
import LegislationMarineRelatedInfomation from "../Pages/LegislationPage/LegislationTab/LegislationMarineRelatedInfomation";
import LegislationMarineNotices from "../Pages/LegislationPage/LegislationTab/LegislationMarineNotices";
import LegislationMarineInformationNotices from "../Pages/LegislationPage/LegislationTab/LegislationMarineInformationNotices";
import LegislationMarineAlerts from "../Pages/LegislationPage/LegislationTab/LegislationMarineAlerts";
import LegislationMarineSafetyFlash from "../Pages/LegislationPage/LegislationTab/LegislationMarineSafetyFlash";
import LegislationTrainingStandardsCode from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode";
import LegislationTrainingStandardsCode2 from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode2";
import LegislationTrainingStandardsCode3 from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode3";
import LegislationTrainingStandardsCode4 from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode4";
import LegislationTrainingStandardsCode5 from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode5";
import LegislationTrainingStandardsCode6 from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode6";
import LegislationTrainingStandardsCode7 from "../Pages/LegislationPage/LegislationTab/LegislationTrainingStandardsCode7";
import LegislationInternationalInstrumentsCode from "../Pages/LegislationPage/LegislationTab/LegislationInternationalInstrumentsCode";
import LegislationInternationalInstrumentsCode2 from "../Pages/LegislationPage/LegislationTab/LegislationInternationalInstrumentsCode2 ";
import LegislationInternationalInstrumentsCode3 from "../Pages/LegislationPage/LegislationTab/LegislationInternationalInstrumentsCode3";
import LegislationInternationalInstrumentsCode4 from "../Pages/LegislationPage/LegislationTab/LegislationInternationalInstrumentsCode4";
import LegislationDraftRegulations from "../Pages/LegislationPage/LegislationTab/LegislationDraftRegulations";
import LegislationSearchResults from "../Pages/LegislationPage/LegislationTab/LegislationSearchResults";

const LegislationAccordionSections = [
  {
    title: "ACTS AND REGULATIONS",
    items: [
      { id: "acts-overview", label: "OVERVIEW", component: <LegislationOverview /> },
      { id: "acts", label: "ACTS", component: <LegislationAct /> },
      { id: "regulations", label: "REGULATIONS", component: <LegislationRegulation /> },
    ],
  },
  {
    title: "MARINE RELATED",
    items: [
      { id: "marine-related", label: "Marine RELATED INFORMATION", component: <LegislationMarineRelatedInfomation/> },
      { id: "marine-notices", label: "MARINE NOTICES", component: <LegislationMarineNotices /> },
      { id: "marine-information-notices", label: "MARINE INFORMATION NOTICE", component: <LegislationMarineInformationNotices /> },
      { id: "marine-alert", label: "MARINE ALERT", component: <LegislationMarineAlerts /> },
      { id: "marine-safety-flash", label: "MARINE SAFETY FLASH", component: <LegislationMarineSafetyFlash /> },
    ],
  },
  {
    title: "TRAINING STANDARDS CODES",
    items: [
      { id: "training-standards", label: "Deck Officers", component: <LegislationTrainingStandardsCode/> },
      { id: "training-standards-code-2", label: "Engineering Officers", component: <LegislationTrainingStandardsCode2 /> },
      { id: "training-standards-code-3", label: "Ratings", component: <LegislationTrainingStandardsCode3 /> },
      { id: "training-standards-code-4", label: "Radio Operators", component: <LegislationTrainingStandardsCode4 /> },
      { id: "training-standards-code-5", label: "Special Ships", component: <LegislationTrainingStandardsCode5 /> },
      { id: "training-standards-code-6", label: "Occupational Health, Safety and Security", component: <LegislationTrainingStandardsCode6 /> },
      { id: "training-standards-code-7", label: "Other training", component: <LegislationTrainingStandardsCode7 /> },

    ],
  },
  {
    title: "INTERNATIONAL INSTRUMENTS",
    items: [
      { id: "intl-instruments", label: "INSTRUMENTS", component: <LegislationInternationalInstrumentsCode /> },
      // { id: "intl-instruments-code-2", label: "INSTRUMENTS 2", component: <LegislationInternationalInstrumentsCode2/> },
      // { id: "intl-instruments-code-3", label: "INSTRUMENTS 3", component: <LegislationInternationalInstrumentsCode3 /> },
      // { id: "intl-instruments-code-4", label: "INSTRUMENTS 4", component: <LegislationInternationalInstrumentsCode4 /> },
    
    ],
  },
   {
    title: "DRAFT REGULATIONS ",
    items: [
      { id: "Draft-Regulations", label: "LegislationDraftRegulations", component: <LegislationDraftRegulations /> },
      
    ],
  },
    {
    title: "SEARCH RESULTS",
    items: [
      { id: "search-results", label: "Results", component: <LegislationSearchResults /> }
    ]
  }
];

export default LegislationAccordionSections;